<template>
	<v-col class="transfer-ewallet">
		<ModalConfirm ref="modalConfirm" :msg="msgConfirm" @action="processTransaction"></ModalConfirm>
		<ModalSetPin ref="modalSetPin" :msg="msgPinConfirm" :datamsg="params" :isActiveMember="isActiveMember" @action="setPinAction"></ModalSetPin>
		<ModalSuccess ref="modalSuccess" :msg="msgSuccess"></ModalSuccess>
		<ModalFailed ref="modalFailed" :data="msgConfirm" :msg="msgFailed"></ModalFailed>
		<div class="d-flex justify-space-between">
			<div class="text-h5 cl-primary">Transfer Saldo</div>
		</div>
		<div class="pt-1 pb-2 d-flex font-size-10 grey--text">
			<v-icon small color="grey">mdi-wallet</v-icon>
			<div class="pl-2">E-wallet</div>
			<div class="px-2">/</div>
			<div>Transfer Saldo</div>
		</div>
		<div class="mt-5">
			<v-row>
				<v-col cols="12" sm="6" md="5" class="mb-0">
					<v-card class="pa-5 elevation-0 rounded-lg hover-shadow">
						<v-row>
							<v-col cols="2" sm="2" md="2" class="pr-0 my-auto text-center">
								<img class="img-fluid" src="/assets/icon/saldo.png">
							</v-col>
							<v-col cols="10" sm="9" md="9">
								<div class="font-size-16 blue--text font-weight-600">{{ ewalletSummary.ewallet_product_balance | toRupiah }}</div>
								<div class="font-size-10 cl-grey">Total Saldo Belanja</div>
							</v-col>
						</v-row>
					</v-card>
				</v-col>
			</v-row>
			
			<v-row>
				<v-col cols="12" sm="6" md="5">
					<v-card class="elevation-0 rounded-lg">
						<div class="px-3 py-3 bg-primary-gradient">
							<div class="text-center cl-white font-size-16 font-weight-bold">Form Transfer Saldo</div>
						</div>
						<div class="px-5">
							<v-form ref="formTransfer" role="form">
								<v-col v-if="false">
									<v-autocomplete label="Kode Penerima" color="primary" class="input-regis" prepend-inner-icon="mdi-account" append-icon="" hide-no-data hide-details="auto" :items="memberSearchList" :loading="isLoading" :search-input.sync="search" item-text="member_network_code" item-value="member_network_code" return-object :rules="rules.input" v-model="params.code">
									</v-autocomplete>
								</v-col>
								<v-col class="">
									<v-text-field label="Kode Penerima" color="primary" class="input-regis" prepend-inner-icon="mdi-account" hide-details="auto" :rules="rules.input" v-model="params.code" @change="hideInvalidCode"></v-text-field>
									<div v-if="invalidCode" class="pt-1 font-size-10 red--text">Kode Penerima tidak sesuai</div>
								</v-col>
								<v-col class="">
									<v-currency-field label="Nominal Transfer" color="primary" class="input-regis" prepend-inner-icon="mdi-database" hide-details="auto" :rules="rules.input" v-model="params.nominal"></v-currency-field>
								</v-col>
								<!-- <v-col class="">
									<v-text-field label="Password Anda" color="primary" class="input-regis" prepend-inner-icon="mdi-key-variant" hide-details="auto" :type="typeInput0" :append-icon="icon0" @click:append="showPassword0" :rules="rules.password" v-model="params.password"></v-text-field>
								</v-col> -->
								<v-col class="">
									<v-textarea label="Catatan" color="primary" class="input-regis" prepend-inner-icon="mdi-format-float-left" hide-details="auto" :rules="rules.input" no-resize rows="3" auto-grow v-model="params.note"></v-textarea>
								</v-col>
								<v-col class="py-5">
									<v-btn large depressed block class="bg-primary-gradient white--text rounded-lg font-weight-bold" tabindex="5" :loading="btnLoadingProses" @click="showConfirm(params)">
										<v-icon>mdi-arrow-right-circle</v-icon>
										<span class="pl-2">Proses</span>
									</v-btn>
								</v-col>
							</v-form>
						</div>
					</v-card>
				</v-col>
			</v-row>
		</div>
	</v-col>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import ModalConfirm from './components/ModalConfirm';
import ModalSetPin from './components/ModalSetPin';
import ModalSuccess from './components/ModalSuccess';
import ModalFailed from './components/ModalFailed';

export default {
	components: {
		ModalConfirm, ModalSetPin, ModalSuccess, ModalFailed
	},
	data() {
		return {
			btnLoadingProses: false,
			typeInput0: 'password',
			icon0: 'mdi-eye',
			search: null,
			memberSearchList: [],
			isLoading: false,
			msgConfirm: {},
			msgPinConfirm: {},
			msgSuccess: {},
			msgFailed: {},
			invalidCode: false,
			existPIN: false,
			isActiveMember: false,
			params: {
				code: '',
				name: '',
				nominal: '',
				password: '',
				ewallet_sender_pin: '',
				note: '',
			},
			rules: {
				input: [
				v => !!v || 'Tidak boleh kosong',
				],
				securepin: [
				v => !!v || 'Tidak boleh kosong',
				v => ( v && v.length >= 6 ) || "PIN tidak boleh kurang dari 6 angka",
				],
			},
		}
	},
	computed: {
		...mapState('ewallet', ['autocompleteMitra', 'ewalletSummary', 'responseSuccess'])
	},
	methods: {
		...mapActions('ewallet', ['getAutocompleteMitra', 'getEwalletSummary', 'transferEwallet', 'checkPinPramitra', 'checkPinMitra', 'setPinMitra', 'setPinPramitra']),

		showPassword0() {
			this.typeInput0 = this.typeInput0 == 'text' ? 'password' : 'text'
			this.icon0 = this.icon0 == 'mdi-eye' ? 'mdi-eye-off' : 'mdi-eye'
		},
		hideInvalidCode() {
			this.invalidCode = false
		},
		async checkMemberActivation(data) {
			if (data.bin_network_id === "0" || data.bin_network_id === 0) this.isActiveMember = false
			else this.isActiveMember = true
		},
		checkPinExist() {
			if(this.isActiveMember) {
				this.checkPinMitra()
					.then(async response => {
						this.existPIN = await response.data
					})
			} else {
				this.checkPinPramitra()
					.then(async response => {
						this.existPIN = await response.data
					})
			}
		},
		setPinAction() {
			this.checkPinExist()
			setTimeout(()=>{
				this.showConfirm(this.params)
				this.btnLoadingProses = false
			}, 1000)
		},
		showConfirm(data) {
			if (this.$refs.formTransfer.validate()) {
				this.btnLoadingProses = true
				if(!this.existPIN) {
					this.$refs.modalSetPin.modalShow()
					this.msgPinConfirm = 'show'
					this.btnLoadingProses = false
				} else {
					this.getAutocompleteMitra({search: this.params.code, page: 1, mode: 'strict'}).then(()=> {
						if (this.autocompleteMitra.length > 0) {
							data.name = this.autocompleteMitra[0].member_name
							this.msgConfirm = data
							this.$refs.modalConfirm.modalShow()
							this.btnLoadingProses = false
						} else {
							this.invalidCode = true
							this.btnLoadingProses = false
						}
					})
				}
			}
		},
		processTransaction() {
			this.$refs.modalConfirm.loadingButton()
			if (this.$refs.formTransfer.validate()) {
				this.transferEwallet({ 
					ewallet_receiver_network_code: this.params.code, 
					ewallet_receiver_value: this.params.nominal, 
					ewallet_sender_pin: this.params.ewallet_sender_pin, 
					ewallet_note: this.params.note })
				.then((response) => {
					if (response.status == 200) {
						this.getEwalletSummary()
						this.msgConfirm = {}
						this.$refs.modalConfirm.normalButton()
						this.$refs.modalConfirm.modalHide()
						this.msgSuccess = this.responseSuccess
						setTimeout(this.$refs.modalSuccess.modalShow(), 500)
						this.$refs.formTransfer.reset()
					} else {
						this.$refs.modalConfirm.normalButton()
						this.btnLoadingProses = false
					}
				}).catch(() => {
					this.$refs.modalConfirm.normalButton()
					this.$refs.modalConfirm.modalHide()
					setTimeout(this.$refs.modalConfirm.modalShow(), 300)
				})
			}
		},
		resetInput() {
			this.params.code = null
			this.params.nominal = null
			this.params.password = null
			this.params.ewallet_sender_pin = null
			this.params.note = null
			this.memberSearchList = []
		},
	},
	watch: {
		search(val) {
			if (!this.search)
				return
			if (val.length >= 3) {
				if (this.isLoading)
					return

				this.isLoading = true

				setTimeout(()=>{
					this.getAutocompleteMitra({search: val}).then(() => {
						this.memberSearchList = this.autocompleteMitra
						this.memberSearchList.map(entry => {
							return Object.assign({}, entry)
						})
					}).catch(() => {
						this.memberSearchList = []
					}).finally(() => (this.isLoading = false))
				}, 1000);
			}
			if (val.length <= 2) {
				this.memberSearchList = []
			}
		}
	},
	async created(){
		const authData = await localStorage.getItem('mlmcore-vo-auth-data');
		const data = await JSON.parse(authData)
		await this.checkMemberActivation(data)

		await this.$store.dispatch('setPageTitle', `Transfer Saldo`)
		await this.checkPinExist()
		await this.getEwalletSummary()

		setTimeout(()=>{
			if(!this.existPIN) {
				this.$refs.modalSetPin.modalShow()
				this.msgPinConfirm = 'show'
				this.btnLoadingProses = false
			}
		}, 1000)
	}
};
</script>